// Routes de l'option « Contrats de maintenance » (lot 1). Option inactive : les pages répondent « introuvable ».
import type { RouteObject } from 'react-router';
import '../../styles/interventions.css';
import '../../styles/chantiers.css';
import '../../styles/bons.css';
import '../../styles/contrats.css';
import { PageContrats } from './PageContrats.tsx';
import { PageContrat } from './PageContrat.tsx';
import { PageModelesContrats } from './PageModelesContrats.tsx';
import { PageVisites } from './PageVisites.tsx';
import { PageVisite } from './PageVisite.tsx';

export const routesContrats: RouteObject[] = [
  { path: 'contrats', element: <PageContrats /> },
  { path: 'contrats/modeles', element: <PageModelesContrats /> },
  { path: 'contrats/:id', element: <PageContrat /> },
  { path: 'interventions/visites', element: <PageVisites /> },
  { path: 'interventions/visites/:id', element: <PageVisite /> },
];
